import { IApplicationState } from '../../types/redux';

export const selectListingOffers = (state: IApplicationState) => {
  return state.listingOffers.offers;
};
